import { dateToTime } from './';
// Inject option if it was filtered out
export const injectOption = (options, option) => {
    if (!option)
        return options;
    // Check whether option exist in options
    const hasOption = options.some((o) => dateToTime(o === null || o === void 0 ? void 0 : o.value) === dateToTime(option === null || option === void 0 ? void 0 : option.value));
    if (!hasOption) {
        options.push(option); // Inject option if needed
        options.sort((d1, d2) => d1.value.getTime() - d2.value.getTime());
    }
    return options;
};
//# sourceMappingURL=injectOption.js.map